/** JCAT-6294: 体験タグからハブページへのパスを組み立てる。 */
import type { WabunkaExperienceTagListViewModel } from '@/wabunka-src/features/Experience/models/wabunkaExperienceTag';

/** JCAT-6294: 最初の destination タグからエリアハブのパスを返す。 */
export const buildDestinationHubPath = (tags: WabunkaExperienceTagListViewModel): string | undefined => {
  const webPath = tags.find((tag) => tag.tag.tagGroupType === 'destination')?.tag.webPath;
  return webPath ? `/${webPath}/` : undefined;
};
